import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
// import HomePage from '../features/home/HomePage'
import ROUTES from '../config/routes'
import PageWrapper from '../components/layout/pagewrapper/PageWrapper'

const HomePage = React.lazy(() => import('../features/home/HomePage'));
const ServicesPage = React.lazy(() => import('../features/services/ServicesPage'));
const Work = React.lazy(() => import('../features/work/Work'));
const Robotics = React.lazy(() => import('../features/robotics/Robotics'));
const About = React.lazy(() => import('../features/about/About'));
const Contact = React.lazy(() => import('../features/contact/Contact'));
const PrivacyPolicy = React.lazy(() => import('../features/legal/PrivacyPolicy'));
const TermsOfService = React.lazy(() => import('../features/legal/TermsOfService'));
const CookiePolicy = React.lazy(() => import('../features/legal/CookiePolicy'));
const NotFoundPage = React.lazy(() => import('../features/not-found/NotFound'));

export default function AppRoutes() {
    return (
        <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
            <Routes>
                <Route
                    path={ROUTES.HOME || '/'}
                    element={
                        <PageWrapper>
                            <HomePage />
                        </PageWrapper>
                    }
                />
                <Route
                    path={ROUTES.SERVICES || '/services'}
                    element={
                        <PageWrapper>
                            <ServicesPage />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.WORK || '/work'}
                    element={
                        <PageWrapper>
                            <Work />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.ROBOTICS || '/robotics'}
                    element={
                        <PageWrapper>
                            <Robotics />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.ABOUT || '/about'}
                    element={
                        <PageWrapper>
                            <About />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.CONTACT || '/contact'}
                    element={
                        <PageWrapper>
                            <Contact />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.PRIVACY || '/privacy-policy'}
                    element={
                        <PageWrapper>
                            <PrivacyPolicy />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.TERMS || '/terms-of-service'}
                    element={
                        <PageWrapper>
                            <TermsOfService />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.COOKIES || '/cookie-policy'}
                    element={
                        <PageWrapper>
                            <CookiePolicy />
                        </PageWrapper>
                    }
                />

                <Route
                    path={ROUTES.NOT_FOUND || '/*'}
                    element={
                        <PageWrapper>
                            <NotFoundPage />
                        </PageWrapper>
                    }
                />
            </Routes>
        </Suspense>
    )
}
